"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Chip = require("./Chip.style");

var _styledSystem = require("styled-system");

var _Icon = _interopRequireDefault(require("../icon/Icon"));

var _utils = require("../lib/utils");

var _excluded = ["label", "id", "icon", "onDelete", "onClick", "value"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var Chip = function Chip(_ref) {
  var label = _ref.label,
      id = _ref.id,
      icon = _ref.icon,
      onDelete = _ref.onDelete,
      _onClick = _ref.onClick,
      value = _ref.value,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var hasDelete = onDelete && typeof onDelete === 'function';
  return /*#__PURE__*/_react["default"].createElement(_Chip.StyledChip, (0, _extends2["default"])({
    hasDelete: hasDelete,
    onClick: function onClick(e) {
      return typeof _onClick === 'function' && _onClick(e, label, id);
    }
  }, props), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, label && /*#__PURE__*/_react["default"].createElement("span", {
    className: "eui-chip-label"
  }, label), /*#__PURE__*/_react["default"].createElement("span", {
    className: "eui-chip-value"
  }, value), hasDelete && /*#__PURE__*/_react["default"].createElement("span", {
    className: "eui-chip-close"
  }, icon ? icon : /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    iconName: "Cross",
    size: props.size === 'small' ? 16 : 20,
    fill: (0, _utils.getPalette)('dark', '300')(),
    onClick: function onClick(e) {
      return typeof onDelete === 'function' && onDelete(e, label, id);
    }
  }))));
};

Chip.defaultProps = {
  hover: false,
  size: 'default'
};
Chip.propTypes = _objectSpread(_objectSpread(_objectSpread({
  className: _propTypes["default"].string
}, _styledSystem.width.propTypes), _styledSystem.space.propTypes), {}, {
  size: _propTypes["default"].oneOf(['small', 'default']),
  width: _propTypes["default"].string,

  /**
   * Icon component can be passed eg: `<Icon iconName='Cross' size={20}/>`
   */
  icon: _propTypes["default"].node,

  /**
   * (event, label) => {}
   */
  onClick: _propTypes["default"].func,

  /**
   * (event, label) => {}
   */
  onDelete: _propTypes["default"].func,
  shadow: _propTypes["default"].bool,
  hover: _propTypes["default"].bool
});
var _default = Chip;
exports["default"] = _default;